(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1995],{

/***/ 88311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DigitalClubEntryPoint_DigitalClubEntryPoint; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@ntuctech/devex-tangram/Theme/NdsThemeProvider.js
var NdsThemeProvider = __webpack_require__(54285);
var NdsThemeProvider_default = /*#__PURE__*/__webpack_require__.n(NdsThemeProvider);
// EXTERNAL MODULE: ./node_modules/@ntuctech/devex-tangram/Box/index.js
var Box = __webpack_require__(87706);
var Box_default = /*#__PURE__*/__webpack_require__.n(Box);
// EXTERNAL MODULE: ./node_modules/@ntuctech/devex-tangram/Typography/index.js
var Typography = __webpack_require__(48663);
var Typography_default = /*#__PURE__*/__webpack_require__.n(Typography);
// EXTERNAL MODULE: ./node_modules/@ntuctech/devex-tangram/Button/ButtonContained.js
var ButtonContained = __webpack_require__(54136);
var ButtonContained_default = /*#__PURE__*/__webpack_require__.n(ButtonContained);
// EXTERNAL MODULE: ./node_modules/@ntuctech/devex-tangram/Icon/SvgLinkPoints.js
var SvgLinkPoints = __webpack_require__(42082);
var SvgLinkPoints_default = /*#__PURE__*/__webpack_require__.n(SvgLinkPoints);
// EXTERNAL MODULE: ./routes.js
var routes = __webpack_require__(93254);
// EXTERNAL MODULE: ./lib/Media.js
var Media = __webpack_require__(9505);
// EXTERNAL MODULE: ./lib/eventTrackerFunction.js
var eventTrackerFunction = __webpack_require__(31035);
// EXTERNAL MODULE: ./utils/LocalStorageService.js
var LocalStorageService = __webpack_require__(50709);
// EXTERNAL MODULE: ./utils/configService/index.js
var configService = __webpack_require__(66738);
// EXTERNAL MODULE: ./utils/constants/index.js
var constants = __webpack_require__(43354);
// EXTERNAL MODULE: ./utils/constants/general.js
var general = __webpack_require__(18197);
// EXTERNAL MODULE: ./utils/userType.js
var userType = __webpack_require__(35084);
// EXTERNAL MODULE: ./components/Layout/Layout.jsx + 2 modules
var Layout = __webpack_require__(45996);
// EXTERNAL MODULE: ./components/Text/Text.jsx
var Text = __webpack_require__(97322);
// EXTERNAL MODULE: ./components/Image/Image.jsx
var Image = __webpack_require__(50994);
// EXTERNAL MODULE: ./components/BenefitNote/BenefitNote.jsx
var BenefitNote = __webpack_require__(70618);
;// CONCATENATED MODULE: ./components/icons/svg/unqualified-circular-icon.svg
/* harmony default export */ var unqualified_circular_icon = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNS40ODUzIDI1LjQ4NTFDMjAuNzk5IDMwLjE3MTQgMTMuMjAxIDMwLjE3MTQgOC41MTQ3MiAyNS40ODUxQzMuODI4NDMgMjAuNzk4OCAzLjgyODQzIDEzLjIwMDkgOC41MTQ3MiA4LjUxNDU4QzEzLjIwMSAzLjgyODI5IDIwLjc5OSAzLjgyODI5IDI1LjQ4NTMgOC41MTQ1OEMzMC4xNzE2IDEzLjIwMDkgMzAuMTcxNiAyMC43OTg4IDI1LjQ4NTMgMjUuNDg1MVpNMjEuNzczIDIxLjc3MjlDMjEuMTg3MiAyMi4zNTg3IDIwLjIzNzUgMjIuMzU4NyAxOS42NTE3IDIxLjc3MjlMMTcgMTkuMTIxM0wxNC4zNDg0IDIxLjc3MjlDMTMuNzYyNiAyMi4zNTg3IDEyLjgxMjkgMjIuMzU4NyAxMi4yMjcxIDIxLjc3MjlDMTEuNjQxMyAyMS4xODcxIDExLjY0MTMgMjAuMjM3NCAxMi4yMjcxIDE5LjY1MTZMMTQuODc4NyAxN0wxMi4yMjcxIDE0LjM0ODNDMTEuNjQxMyAxMy43NjI1IDExLjY0MTMgMTIuODEyOCAxMi4yMjcxIDEyLjIyN0MxMi44MTI4IDExLjY0MTIgMTMuNzYyNiAxMS42NDEyIDE0LjM0ODQgMTIuMjI3TDE3IDE0Ljg3ODZMMTkuNjUxNyAxMi4yMjY5QzIwLjIzNzUgMTEuNjQxMiAyMS4xODczIDExLjY0MTIgMjEuNzczIDEyLjIyNjlDMjIuMzU4OCAxMi44MTI3IDIyLjM1ODggMTMuNzYyNSAyMS43NzMgMTQuMzQ4M0wxOS4xMjE0IDE3TDIxLjc3MyAxOS42NTE2QzIyLjM1ODggMjAuMjM3NCAyMi4zNTg4IDIxLjE4NzEgMjEuNzczIDIxLjc3MjlaIiBmaWxsPSIjOTk5OTk5Ii8+Cjwvc3ZnPgo=");
// EXTERNAL MODULE: ./components/icons/svg/qualified-circular-icon.svg
var qualified_circular_icon = __webpack_require__(52923);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/icons/ChevronLight.js

var _excluded = ["title"];




var Chevron = function Chevron(_ref) {
  var title = _ref.title,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#1557BF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.35",
      d: "M6 13l4-4-4-4"
    })]
  }));
};

/* harmony default export */ var ChevronLight = (Chevron);
// EXTERNAL MODULE: ./static/FPDigitalClubLogo/image@4x.png
var image_4x = __webpack_require__(30119);
var image_4x_default = /*#__PURE__*/__webpack_require__.n(image_4x);
// EXTERNAL MODULE: ./static/Membership/Registration/image.jpg
var Registration_image = __webpack_require__(69713);
var image_default = /*#__PURE__*/__webpack_require__.n(Registration_image);
// EXTERNAL MODULE: ./static/Membership/Registration/image@2x.jpg
var image_2x = __webpack_require__(12232);
var image_2x_default = /*#__PURE__*/__webpack_require__.n(image_2x);
// EXTERNAL MODULE: ./static/Membership/Registration/image@3x.jpg
var image_3x = __webpack_require__(63985);
var image_3x_default = /*#__PURE__*/__webpack_require__.n(image_3x);
// EXTERNAL MODULE: ./components/DigitalClub/ProfileSwitchPopup/ProfileSwitchPopup.jsx
var ProfileSwitchPopup = __webpack_require__(58907);
;// CONCATENATED MODULE: ./components/DigitalClub/DigitalClubEntryPoint/DigitalClubEntryPoint.jsx








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
































var StyledLayout = (0,styled_components_browser_esm["default"])(Layout/* default */.Z).withConfig({
  componentId: "sc-mmz85i-0"
})(["& main{", "{padding:0;}}"], Media/* SCREEN_SIZE.Below.Tablet */.yJ.Below.Tablet);
var ContentLayer = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-1"
})(["position:relative;color:#333333;"]);
var ContentBodyWrapper = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-2"
})(["margin-top:1rem;.tangram-linkpoint-icon{height:1.5rem;width:1.5rem;}"]);
var MiddleContent = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-3"
})(["", " text-align:center;padding:0.5rem 0.5rem 1rem 0.5rem;"], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor && "background-color: ".concat(backgroundColor, ";");
});
var HighlightedText = (0,styled_components_browser_esm["default"])(Text/* default */.ZP).withConfig({
  componentId: "sc-mmz85i-4"
})(["margin-bottom:0.5rem;text-align:center;"]);
var BottomCard = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-5"
})(["text-align:center;color:#333333;border-top:0.0625rem solid #eaeaea;padding:1.5rem 0;margin:1.5rem 1.5rem 0;"]);
var FeeText = (0,styled_components_browser_esm["default"])(Text/* default */.ZP).withConfig({
  componentId: "sc-mmz85i-6"
})(["font-size:2.25rem;margin:auto 0.15rem;"]);
var Table = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-7"
})(["margin:0.5rem 0.5rem;", "{margin:0.5rem 3.75rem;}position:relative;"], Media/* SCREEN_SIZE.From.MobileL */.yJ.From.MobileL);
var FirstColumn = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-8"
})(["flex:1 1 auto;min-height:3.5rem;padding:0.5rem 0.5rem;display:flex;align-items:flex-start;justify-content:center;flex-direction:column;"]);
var SecondColumn = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-9"
})(["", "{width:6.5rem;}width:7.5rem;flex:0 0 auto;min-height:3.5rem;padding:0 0.5rem;display:flex;align-items:center;justify-content:center;flex-direction:column;"], Media/* SCREEN_SIZE.Only.Mobile */.yJ.Only.Mobile);
var ThirdColumn = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-10"
})(["", "{width:6.5rem;}width:7.5rem;flex:0 0 auto;min-height:3.5rem;padding:0.2rem 0.5rem;display:flex;align-items:center;justify-content:center;flex-direction:column;"], Media/* SCREEN_SIZE.Only.Mobile */.yJ.Only.Mobile);
var Row = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-11"
})(["border-bottom:0.0625rem solid #eaeaea;min-height:3.5rem;width:100%;display:flex;background-color:white;&:nth-child(even){background-color:#f4f5f7;}"]);
var TableNoteContainer = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-12"
})(["display:flex;margin:1rem auto 0;> div{margin:0 auto;}"]);
var HighlightedThirdColumnArea = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-13"
})(["border:0.125rem solid #1557bf;border-radius:0.5rem;", "{width:6.5rem;}width:7.5rem;height:100%;position:absolute;top:0;right:0;"], Media/* SCREEN_SIZE.Only.Mobile */.yJ.Only.Mobile);
var StyledLink = styled_components_browser_esm["default"].a.withConfig({
  componentId: "sc-mmz85i-14"
})(["text-decoration:none;color:#1557bf;font-size:0.875rem;line-height:1.25rem;cursor:pointer;&:visited{color:#1557bf;}"]);
var FeeContainer = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-15"
})(["margin-top:1rem;"]);
var LogoContainer = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-16"
})(["margin:0.625rem 0.8125rem 0.2rem;"]);
var ReservedLogoSpace = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-17"
})(["height:2.1rem;"]);
var FlexBox = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-18"
})(["display:flex;"]);
var PromoLink = styled_components_browser_esm["default"].a.withConfig({
  componentId: "sc-mmz85i-19"
})(["text-decoration:none;display:flex;.hide-mobile-text{", "{display:none;}}svg{vertical-align:middle;}"], Media/* SCREEN_SIZE.Only.Mobile */.yJ.Only.Mobile);
var PromoLinkMobileText = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-20"
})(["", "{display:flex;flex-direction:column;}", "{display:none;}"], Media/* SCREEN_SIZE.Only.Mobile */.yJ.Only.Mobile, Media/* SCREEN_SIZE.From.MobileL */.yJ.From.MobileL);
var ButtonContainer = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-21"
})(["margin:1rem auto 0.5rem;width:16.25rem;"]);
var InfoCard = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-22"
})(["background-color:white;max-width:37.5rem;margin:0 auto;position:relative;"]);
var PageDescription = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-mmz85i-23"
})(["", "{margin:auto 0.5rem;}"], Media/* SCREEN_SIZE.Only.Mobile */.yJ.Only.Mobile);
var DC_TAGLINE_OLD = 'Free delivery, zero service fee, lower prices and earn 2x Linkpoints when you shop online.';

var DC_TAGLINE_NEW = /*#__PURE__*/(0,jsx_runtime.jsx)((Box_default()), {
  my: 2,
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)((Typography_default()), {
    variant: "body2",
    children: ["Enjoy a free 1-month membership and exclusive benefits.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Pay just $9.99/month after your trial. For eligible customers only."]
  })
});

var BenefitTable = function BenefitTable() {
  var dcBenefitDetailsSplit = (0,configService.getExpConfig)(constants.SPLIT_FEATURES.DC_FREE_TRIAL_BENEFITS);
  var dcBenefitDetails = JSON.parse((dcBenefitDetailsSplit === null || dcBenefitDetailsSplit === void 0 ? void 0 : dcBenefitDetailsSplit.config) || JSON.stringify(general/* DEFAULT_BENEFIT_CONFIGS */.ch));
  var _dcBenefitDetails$dcL = dcBenefitDetails.dcLogo,
      dcLogo = _dcBenefitDetails$dcL === void 0 ? (image_4x_default()) : _dcBenefitDetails$dcL;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentBodyWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HighlightedText, {
      as: "p",
      size: "xl",
      color: "#104393",
      weight: "bold",
      children: "What you will enjoy"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FirstColumn, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(SecondColumn, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoContainer, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReservedLogoSpace, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            weight: "bold",
            margin: "0 0 0.375rem 0",
            children: "Non-member"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ThirdColumn, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoContainer, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
              altText: "FairPrice Digital Club Logo",
              src: dcLogo,
              width: "100%",
              height: "100%",
              noLazyLoading: true
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            weight: "black",
            children: "Member"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FirstColumn, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            weight: "bold",
            children: "Service fee"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SecondColumn, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            weight: "black",
            size: "large",
            children: "$3.99"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            size: "small",
            children: "per order"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ThirdColumn, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            weight: "black",
            size: "large",
            children: "Waived*"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FirstColumn, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            weight: "bold",
            children: "Linkpoints"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            size: "small",
            children: "Earn 2X Linkpoints"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SecondColumn, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexBox, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((SvgLinkPoints_default()), {
              className: "tangram-linkpoint-icon",
              "data-testid": "linkpoint-icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
              as: "p",
              weight: "black",
              size: "large",
              margin: "0 0 0 0.375rem",
              children: "0.50"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            size: "small",
            children: "every $1 spend"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ThirdColumn, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexBox, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((SvgLinkPoints_default()), {
              className: "tangram-linkpoint-icon",
              "data-testid": "linkpoint-icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
              as: "p",
              weight: "black",
              size: "large",
              margin: "0 0 0 0.375rem",
              children: "1"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            size: "small",
            children: "every $1 spend"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FirstColumn, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            weight: "bold",
            children: "Exclusive promotions"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            size: "small",
            children: "(Over $10 savings monthly)"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/tag/digital-club-promos",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PromoLink, {
              "data-testid": "dc-promo-link",
              target: "_blank",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
                color: "#1557bf",
                size: "small",
                margin: "auto 0",
                children: "View all promos"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronLight, {})]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SecondColumn, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            alt: "Unqualified",
            src: unqualified_circular_icon
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ThirdColumn, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            alt: "Unqualified",
            src: qualified_circular_icon/* default */.Z
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FirstColumn, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            weight: "bold",
            children: "Lifestyle deals"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/promo/digital-club-partner-deals",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PromoLink, {
              "data-testid": "dc-partner-deals-link",
              target: "_blank",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
                color: "#1557bf",
                size: "small",
                margin: "auto 0",
                className: 'hide-mobile-text',
                children: "View our partner deals"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronLight, {
                className: 'hide-mobile-text'
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PromoLinkMobileText, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
                  color: "#1557bf",
                  size: "small",
                  margin: "auto 0",
                  children: "View our partner"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                  color: "#1557bf",
                  size: "small",
                  margin: "auto 0",
                  children: ["deals ", /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronLight, {})]
                })]
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SecondColumn, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            alt: "Unqualified",
            src: unqualified_circular_icon
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ThirdColumn, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            alt: "Unqualified",
            src: qualified_circular_icon/* default */.Z
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HighlightedThirdColumnArea, {})]
    })]
  });
};

var InvitedUserContent = function InvitedUserContent(_ref2) {
  var signUp = _ref2.signUp,
      pageTitle = _ref2.pageTitle,
      pageDescText = _ref2.pageDescText,
      ctaButtonText = _ref2.ctaButtonText,
      ctaButtonInfoText = _ref2.ctaButtonInfoText,
      isUserEligibleForFreeTrial = _ref2.isUserEligibleForFreeTrial,
      isLoggedIn = _ref2.isLoggedIn;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MiddleContent, {
    backgroundColor: "#CEE7F8",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
      as: "p",
      size: "xl",
      color: "#104393",
      weight: "bold",
      margin: "1rem 0 0 0",
      children: pageTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PageDescription, {
      "data-testid": "dc-page-description",
      children: pageDescText
    }), isLoggedIn && !isUserEligibleForFreeTrial && /*#__PURE__*/(0,jsx_runtime.jsxs)(FeeContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
        size: "mxl",
        color: "#0D3578",
        children: "Only"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeeText, {
        weight: "bold",
        color: "#0D3578",
        children: "$9.99"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
        size: "mxl",
        color: "#0D3578",
        children: "/month"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((ButtonContained_default()), {
        compact: true,
        size: "m",
        fullWidth: true,
        onClick: signUp,
        "data-testid": "register-button-above",
        children: ctaButtonText
      })
    }), ctaButtonInfoText]
  });
};

var DigitalClubEntryPoint = /*#__PURE__*/function (_React$PureComponent) {
  (0,inherits/* default */.Z)(DigitalClubEntryPoint, _React$PureComponent);

  var _super = _createSuper(DigitalClubEntryPoint);

  function DigitalClubEntryPoint() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, DigitalClubEntryPoint);

    _this = _super.call(this);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "signUp", function (buttonPosition) {
      var _this$props = _this.props,
          isLoggedIn = _this$props.isLoggedIn,
          login = _this$props.login;

      if (!isLoggedIn) {
        login();
        return;
      }

      if (buttonPosition === 'Top') {
        _this.trackEvent('Click', 'Digital_Club-Join_SignUp_Top');
      } else {
        _this.trackEvent('Click', 'Digital_Club-Join_SignUp_Bottom');
      }

      routes.Router.pushRoute('/membership/checkout');
    });

    var isB2BUser = (0,userType/* getUserType */.N)() === 'B2B';
    _this.state = {
      blueBackgroundSize: {},
      enableProfileSwitchPopup: isB2BUser
    };
    _this.trackEvent = _this.trackEvent.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(DigitalClubEntryPoint, [{
    key: "trackEvent",
    value: function trackEvent(action, label) {
      var _track;

      var track = this.props.track;
      track((_track = {}, (0,defineProperty/* default */.Z)(_track, eventTrackerFunction/* GTM_ENV_VAR.EVENT_CAT */.Zr.EVENT_CAT, 'Account-Membership'), (0,defineProperty/* default */.Z)(_track, eventTrackerFunction/* GTM_ENV_VAR.EVENT_ACTION */.Zr.EVENT_ACTION, action), (0,defineProperty/* default */.Z)(_track, eventTrackerFunction/* GTM_ENV_VAR.EVENT_LABEL */.Zr.EVENT_LABEL, label), (0,defineProperty/* default */.Z)(_track, eventTrackerFunction/* GTM_ENV_VAR.MEMSH_TYPE */.Zr.MEMSH_TYPE, 'DC member'), (0,defineProperty/* default */.Z)(_track, eventTrackerFunction/* GTM_ENV_VAR.PAGE_TYPE */.Zr.PAGE_TYPE, eventTrackerFunction/* PAGE_TYPES.MICRO */.sL.MICRO), (0,defineProperty/* default */.Z)(_track, eventTrackerFunction/* GTM_ENV_VAR.SCREEN_NAME */.Zr.SCREEN_NAME, 'Micro-Membership_Digital_Club'), _track));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          getDcFreeTrialEligibility = _this$props2.getDcFreeTrialEligibility,
          isLoggedIn = _this$props2.isLoggedIn;

      if (isLoggedIn) {
        getDcFreeTrialEligibility().then(function (res) {
          _this2.setState({
            isUserEligibleForFreeTrial: res
          });
        });
      }

      this.trackEvent('Landed', 'Digital_Club-Join_SignUp');
      var isRecentlyLoggedIn = LocalStorageService/* default.getItem */.Z.getItem('login_user') === 'false' && this.props.isLoggedIn;

      if (isRecentlyLoggedIn) {
        routes.Router.pushRoute('/membership/checkout');
        return;
      }

      this.setState({
        blueBackgroundSize: {
          headerStandardHeight: '33rem',
          headerMobileHeight: '31.5rem'
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _remoteConfig$faqLink,
          _remoteConfig$faqLink2,
          _this3 = this;

      var _this$props3 = this.props,
          organizationData = _this$props3.organizationData,
          categoryList = _this$props3.categoryList,
          remoteConfig = _this$props3.remoteConfig;
      var enableProfileSwitchPopup = this.state.enableProfileSwitchPopup;
      var faqLink = (remoteConfig === null || remoteConfig === void 0 ? void 0 : (_remoteConfig$faqLink = remoteConfig.faqLink) === null || _remoteConfig$faqLink === void 0 ? void 0 : (_remoteConfig$faqLink2 = _remoteConfig$faqLink.defaultValue) === null || _remoteConfig$faqLink2 === void 0 ? void 0 : _remoteConfig$faqLink2.value) || '';
      var dcBenefitDetailsSplit = (0,configService.getExpConfig)(constants.SPLIT_FEATURES.DC_FREE_TRIAL_BENEFITS);
      var dcBenefitDetails = JSON.parse((dcBenefitDetailsSplit === null || dcBenefitDetailsSplit === void 0 ? void 0 : dcBenefitDetailsSplit.config) || '{}');
      var _dcBenefitDetails$pro = dcBenefitDetails.promotionBanners,
          promotionBanners = _dcBenefitDetails$pro === void 0 ? [(image_default()), (image_2x_default()), (image_3x_default())] : _dcBenefitDetails$pro,
          nonMemberText = dcBenefitDetails.nonMemberText;
      var bannerSrcSet = "".concat(promotionBanners[0], " 1x, ").concat(promotionBanners[1], " 2x, ").concat(promotionBanners[2], " 3x");
      var defaultBannerSrc = promotionBanners[1]; // DC free trial not eligible

      var pageTitle = 'Be a FairPrice Digital Club member to enjoy exclusive benefits';

      var pageDescText = /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
        as: "p",
        size: "large",
        children: DC_TAGLINE_OLD
      });

      var ctaButtonText = 'Join the club';
      var ctaButtonInfoText = nonMemberText; // DC free trial flag on

      if (this.props.isLoggedIn) {
        if (this.state.isUserEligibleForFreeTrial) {
          pageTitle = 'Get a free Digital Club trial';
          pageDescText = DC_TAGLINE_NEW;
          ctaButtonText = 'Start 1-month free trial';
          ctaButtonInfoText = '';
        } else {
          pageDescText = /*#__PURE__*/(0,jsx_runtime.jsx)((Box_default()), {
            my: 2,
            mx: 6,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((Typography_default()), {
              variant: "body2",
              children: DC_TAGLINE_OLD
            })
          });
        }
      } else {
        pageTitle = 'Get a free Digital Club trial';
        pageDescText = DC_TAGLINE_NEW;
        ctaButtonText = 'Log in to check eligibility';
        ctaButtonInfoText = '';
      }

      var innerContent = /*#__PURE__*/(0,jsx_runtime.jsxs)(InfoCard, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ContentLayer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            altText: "Membership Registration",
            srcSet: bannerSrcSet,
            src: defaultBannerSrc,
            width: "100%",
            height: "100%",
            noLazyLoading: true
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(InvitedUserContent, {
            signUp: function signUp() {
              _this3.signUp('Top');
            },
            pageTitle: pageTitle,
            pageDescText: pageDescText,
            ctaButtonText: ctaButtonText,
            ctaButtonInfoText: ctaButtonInfoText,
            isUserEligibleForFreeTrial: this.state.isUserEligibleForFreeTrial,
            isLoggedIn: this.props.isLoggedIn
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitTable, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(MiddleContent, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonContainer, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((ButtonContained_default()), {
                compact: true,
                size: "m",
                fullWidth: true,
                "data-testid": "register-button-below",
                onClick: function onClick() {
                  _this3.signUp('Bottom');
                },
                children: ctaButtonText
              })
            }), ctaButtonInfoText]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BottomCard, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.ZP, {
            as: "p",
            size: "xl",
            weight: "bold",
            color: "#104393",
            children: "Need help?"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
            href: faqLink,
            children: "Check out our FAQs."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableNoteContainer, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNote/* default */.Z, {})
          })]
        })]
      });

      return /*#__PURE__*/(0,jsx_runtime.jsxs)((NdsThemeProvider_default()), {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
            name: "description",
            content: "Enjoy Everyday Low Prices at Singapore's trusted grocery retailer. FairPrice offers a wide range of products with prices matched online and in stores."
          }, "meta_description"), /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
            children: "NTUC FairPrice | Membership Registration"
          })]
        }), this.props.standAlonePage ? /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLayout, {
          organizationData: organizationData,
          categoryList: categoryList,
          showPostalCodeModule: true,
          children: innerContent
        }) : innerContent, enableProfileSwitchPopup && /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileSwitchPopup/* default */.Z, {})]
      });
    }
  }]);

  return DigitalClubEntryPoint;
}(react.PureComponent);

/* harmony default export */ var DigitalClubEntryPoint_DigitalClubEntryPoint = (DigitalClubEntryPoint);

/***/ }),

/***/ 58907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97322);
/* harmony import */ var _lib_Media__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9505);
/* harmony import */ var _utils_userType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35084);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93254);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_routes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Popup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11884);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);









var PopupContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
  componentId: "sc-ilbvsm-0"
})(["background:#ffffff;box-shadow:0px 2px 4px rgba(51,51,51,0.24);border-radius:4px;padding:1rem;margin:0 1rem;", "{width:20.5rem;height:auto;}"], _lib_Media__WEBPACK_IMPORTED_MODULE_2__/* .SCREEN_SIZE.From.Tablet */ .yJ.From.Tablet);
var Header = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
  componentId: "sc-ilbvsm-1"
})(["position:relative;"]);
var PopupContent = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
  componentId: "sc-ilbvsm-2"
})(["margin-bottom:1.5rem;"]);
var ButtonWrp = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
  componentId: "sc-ilbvsm-3"
})(["display:flex;justify-content:space-evenly;"]);
var Button = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].button.withConfig({
  componentId: "sc-ilbvsm-4"
})(["cursor:pointer;background:#f2f2f2;border-radius:4px;padding:8px 16px;outline:none;border:none;"]);
var ButtonBlue = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Button).withConfig({
  componentId: "sc-ilbvsm-5"
})(["padding:8px 16px;background:#1454b8;border-radius:4px;"]);
var HeaderText = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP).withConfig({
  componentId: "sc-ilbvsm-6"
})(["line-height:1.75rem;"]);
var MainText = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP).withConfig({
  componentId: "sc-ilbvsm-7"
})(["line-height:1.5rem;"]);

var redirectToHomepage = function redirectToHomepage() {
  _routes__WEBPACK_IMPORTED_MODULE_4__.Router.pushRoute("/");
};

var SwitchToB2CProfile = function SwitchToB2CProfile() {
  (0,_utils_userType__WEBPACK_IMPORTED_MODULE_3__/* .setUserType */ .e)('B2C', true, true, null);
};

var ProfileSwitchPopup = function ProfileSwitchPopup() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Popup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    forceAcknowledge: true,
    "data-testid": "interest-registration-popup",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(PopupContainer, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Header, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(HeaderText, {
          size: "xl",
          weight: "bold",
          color: "#333333",
          children: "Digital Club is not available on FairPrice for Business"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(PopupContent, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(MainText, {
          size: "large",
          color: "#333333",
          children: "You can join Digital Club on FairPrice for Personal to enjoy the benefits."
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(ButtonWrp, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Button, {
          onClick: redirectToHomepage,
          "data-testid": "switch-back-to-home",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            size: "medium",
            weight: "bold",
            color: "#333333",
            children: "Back to home"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(ButtonBlue, {
          onClick: SwitchToB2CProfile,
          "data-testid": "switch-to-personal-b2b",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            size: "medium",
            color: "#ffffff",
            weight: "bold",
            align: "center",
            children: "Switch to Personal"
          })
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ProfileSwitchPopup);

/***/ }),

/***/ 45996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/Media.js
var Media = __webpack_require__(9505);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./containers/Header/index.js + 15 modules
var Header = __webpack_require__(30874);
// EXTERNAL MODULE: ./containers/Main/Main.jsx
var Main = __webpack_require__(26217);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/icons/CarouselChevronTop.js

var _excluded = ["title"];




var SvgCarouselChevronTop = function SvgCarouselChevronTop(_ref) {
  var title = _ref.title,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60"
  }, props, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        id: "carousel-chevron-top_svg__b",
        cx: 20,
        cy: 20,
        r: 20
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "carousel-chevron-top_svg__a",
        width: "187.5%",
        height: "187.5%",
        x: "-43.8%",
        y: "-31.2%",
        filterUnits: "objectBoundingBox",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feOffset", {
          dy: 5,
          "in": "SourceAlpha",
          result: "shadowOffsetOuter1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          "in": "shadowOffsetOuter1",
          result: "shadowBlurOuter1",
          stdDeviation: 5
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          "in": "shadowBlurOuter1",
          in2: "SourceAlpha",
          operator: "out",
          result: "shadowBlurOuter1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          "in": "shadowBlurOuter1",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        opacity: 0.8,
        transform: "translate(10 5)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("use", {
          fill: "#000",
          filter: "url(#carousel-chevron-top_svg__a)",
          xlinkHref: "#carousel-chevron-top_svg__b"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: 20,
          cy: 20,
          r: 19.5,
          fill: "#FFF",
          stroke: "#EAEAEA",
          strokeLinejoin: "square"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M35.333 24L30 18.667 24.667 24m10.666 6L30 24.667 24.667 30",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      })]
    })]
  }));
};

/* harmony default export */ var CarouselChevronTop = (SvgCarouselChevronTop);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./components/ScrollToTop/ScrollToTop.jsx







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var MINIMUM_HEIGHT_TO_DISPLAY_SCROLL_ICON = 100;
var fadeIn = (0,styled_components_browser_esm.keyframes)(["0%{opacity:0;}50%{opacity:0.5;}100%{opacity:1;}"]);
var StyledTop = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-nzu4nl-0"
})(["display:", ";position:fixed;right:0.5rem;bottom:1.5rem;z-index:1;cursor:pointer;> svg{width:3.75rem;height:3.75rem;color:#1557bf;}animation:", " 0.35s ease-in;"], function (props) {
  return props.displayScrollTop ? 'block' : 'none';
}, fadeIn);

var ScrollToTop = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(ScrollToTop, _Component);

  var _super = _createSuper(ScrollToTop);

  function ScrollToTop(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ScrollToTop);

    _this = _super.call(this, props);
    _this.state = {};
    _this.handleScrollTopDisplay = throttle_default()(_this.handleScrollTopDisplay.bind((0,assertThisInitialized/* default */.Z)(_this)), 200);
    _this.handleScrollToTop = _this.handleScrollToTop.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(ScrollToTop, [{
    key: "handleScrollTopDisplay",
    value: function handleScrollTopDisplay() {
      var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

      if (scrollTop > MINIMUM_HEIGHT_TO_DISPLAY_SCROLL_ICON !== this.state.displayScrollTop) {
        this.setState({
          displayScrollTop: scrollTop > MINIMUM_HEIGHT_TO_DISPLAY_SCROLL_ICON
        });
      }
    }
  }, {
    key: "handleScrollToTop",
    value: function handleScrollToTop() {
      __webpack_require__.e(/* import() */ 6261).then(__webpack_require__.bind(__webpack_require__, 66261)).then(function (scroll) {
        scroll.animateScroll.scrollToTop({
          duration: 500,
          smooth: true,
          ignoreCancelEvents: false
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleScrollTopDisplay();
      window.addEventListener('scroll', this.handleScrollTopDisplay, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScrollTopDisplay);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTop, {
        onClick: this.handleScrollToTop,
        displayScrollTop: this.state.displayScrollTop,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselChevronTop, {})
      });
    }
  }]);

  return ScrollToTop;
}(react.Component);

/* harmony default export */ var ScrollToTop_ScrollToTop = (ScrollToTop);
// EXTERNAL MODULE: ./components/GlobalContext.jsx
var GlobalContext = __webpack_require__(87279);
// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(57756);
;// CONCATENATED MODULE: ./components/Layout/Layout.jsx








function Layout_createSuper(Derived) { var hasNativeReflectConstruct = Layout_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function Layout_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }













var DeliverySlotHelloBar = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 432).then(__webpack_require__.bind(__webpack_require__, 432));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(432)];
    }
  }
});
var Footer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6986).then(__webpack_require__.bind(__webpack_require__, 26986));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26986)];
    }
  }
});
var Container = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-1e9xyj2-0"
})(["display:flex;flex:1;flex-direction:column;"]);
var FooterWrapper = styled_components_browser_esm["default"].footer.withConfig({
  componentId: "sc-1e9xyj2-1"
})(["flex-shrink:0;", "{display:none;}", "{display:none;}"], Media/* SCREEN_SIZE.Only.Mobile */.yJ.Only.Mobile, Media/* SCREEN_SIZE.Only.MobileL */.yJ.Only.MobileL);
var MainWrapper = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-1e9xyj2-2"
})(["margin:0.8125rem 0 0;", "{margin-top:1rem;padding-left:1.5rem;padding-right:1.5rem;min-height:calc(100vh - 6.25rem - 28.5625rem);}", "{min-height:calc(100vh - 12.625rem - 19.0781rem);}", "{max-width:100rem;margin-left:auto;margin-right:auto;}", ""], Media/* SCREEN_SIZE.From.Tablet */.yJ.From.Tablet, Media/* SCREEN_SIZE.From.Desktop */.yJ.From.Desktop, Media/* SCREEN_SIZE.From.UhdL */.yJ.From.UhdL, function (_ref) {
  var noWrapper = _ref.noWrapper;
  return noWrapper === 'noGap' && 'padding: 0 !important; margin: 0 auto !important;';
});
var Overlay = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-1e9xyj2-3"
})(["", "{position:fixed;top:", ";background-color:rgba(51,51,51,0.8);z-index:100;width:100vw;height:100vh;transition:opacity 0.2s 0.2s,visibility 0.2s 0.2s;opacity:", ";visibility:", ";}"], Media/* SCREEN_SIZE.From.Tablet */.yJ.From.Tablet, function (_ref2) {
  var hasBackdrop = _ref2.hasBackdrop;
  return hasBackdrop ? window && window.getComputedStyle(document.getElementsByTagName('header')[0]).height || '162px' : '';
}, function (_ref3) {
  var hasBackdrop = _ref3.hasBackdrop;
  return hasBackdrop ? '1' : '0';
}, function (_ref4) {
  var hasBackdrop = _ref4.hasBackdrop;
  return hasBackdrop ? 'visible' : 'hidden';
});

var Layout = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Layout, _Component);

  var _super = Layout_createSuper(Layout);

  function Layout(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Layout);

    _this = _super.call(this, props);
    _this.state = {
      backdrop: []
    };
    _this.handleBackdrop = _this.handleBackdrop.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(Layout, [{
    key: "handleBackdrop",
    value: function handleBackdrop(value) {
      var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

      //possibly having many backdrops at the same time
      if (value) {
        if (!this.state.backdrop.some(function (x) {
          return x === component;
        })) {
          this.setState({
            backdrop: [].concat((0,toConsumableArray["default"])(this.state.backdrop), [component])
          });
        }

        return;
      }

      this.setState(function (prevState) {
        return {
          backdrop: prevState.backdrop.filter(function (x) {
            return x !== component;
          })
        };
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _prevState$backdrop;

      if (((_prevState$backdrop = prevState.backdrop) === null || _prevState$backdrop === void 0 ? void 0 : _prevState$backdrop.length) !== this.state.backdrop.length) {
        var shouldDisableScroll = !!this.state.backdrop.length;
        (0,utils/* disablePageScroll */.XD)(shouldDisableScroll);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          organizationData = _this$props.organizationData,
          noWrapper = _this$props.noWrapper,
          noFooter = _this$props.noFooter,
          categoryList = _this$props.categoryList,
          router = _this$props.router;
      var backdrop = this.state.backdrop;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [backdrop && backdrop.length > 0 && (0,utils/* disablePageScroll */.XD)(true), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
          className: className,
          "data-testid": "layout",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
              organizationData: organizationData,
              categoryList: categoryList,
              onHandleBackdrop: this.handleBackdrop,
              hasNewVouchers: this.props.hasNewVouchers,
              hasPaymentAlert: this.props.hasPaymentAlert
            }), (router === null || router === void 0 ? void 0 : router.pathname) === '/' && /*#__PURE__*/(0,jsx_runtime.jsx)(DeliverySlotHelloBar, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Overlay, {
              hasBackdrop: backdrop && backdrop.length > 0
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(MainWrapper, {
              noWrapper: noWrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Main/* default */.Z, {
                noWrapper: noWrapper,
                children: children
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterWrapper, {
            children: noFooter ? '' : /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {
              organizationData: organizationData
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollToTop_ScrollToTop, {})]
        })]
      });
    }
  }]);

  return Layout;
}(react.Component);

Layout.defaultProps = {
  organizationData: {}
};

var LayoutWrapper = function LayoutWrapper(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalContext/* default.Consumer */.Z.Consumer, {
    children: function children(_ref5) {
      var experiments = _ref5.experiments,
          remoteConfig = _ref5.remoteConfig;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout, Object.assign({}, props, {
        experiments: experiments,
        remoteConfig: remoteConfig
      }));
    }
  });
};

/* harmony default export */ var Layout_Layout = ((0,router.withRouter)(LayoutWrapper));

/***/ }),

/***/ 26217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _lib_Media__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9505);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var MainContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].main.withConfig({
  componentId: "sc-mhgwiq-0"
})(["margin:0 auto;min-height:20vh;padding:0 1rem;", "{padding:0 0 2rem 0;}", "{padding-left:0;padding-right:0;}"], _lib_Media__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE.From.Tablet */ .yJ.From.Tablet, _lib_Media__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE.From.Desktop */ .yJ.From.Desktop);
var MainTablet = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(MainContainer).withConfig({
  componentId: "sc-mhgwiq-1"
})(["", "{padding:0.5rem 0;margin:0rem;}"], _lib_Media__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE.From.Tablet */ .yJ.From.Tablet);
var MainDesktop = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(MainContainer).withConfig({
  componentId: "sc-mhgwiq-2"
})(["", "{padding:0.5rem 0;margin:0rem;}"], _lib_Media__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE.From.Desktop */ .yJ.From.Desktop);
var MainHd = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(MainContainer).withConfig({
  componentId: "sc-mhgwiq-3"
})(["", "{padding:0.5rem 0;margin:0rem;}"], _lib_Media__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE.From.Hd */ .yJ.From.Hd);
var NoGapContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(MainContainer).withConfig({
  componentId: "sc-mhgwiq-4"
})(["padding:0;margin:0;"]);

var Main = function Main(_ref) {
  var children = _ref.children,
      _ref$noWrapper = _ref.noWrapper,
      noWrapper = _ref$noWrapper === void 0 ? 'default' : _ref$noWrapper;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: [noWrapper === 'fromMobile' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("main", {
      children: children
    }), noWrapper === 'fromTablet' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(MainTablet, {
      children: children
    }), noWrapper === 'fromDesktop' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(MainDesktop, {
      children: children
    }), noWrapper === 'fromHd' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(MainHd, {
      children: children
    }), noWrapper === 'noGap' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(NoGapContainer, {
      children: children
    }), noWrapper === 'default' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(MainContainer, {
      children: children
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Main);

/***/ }),

/***/ 28743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$u": function() { return /* binding */ checkoutTncHeader; },
/* harmony export */   "G5": function() { return /* binding */ checkoutServiceFooter; },
/* harmony export */   "QC": function() { return /* binding */ getUserDcEligibility; },
/* harmony export */   "mK": function() { return /* binding */ cancelMembershipSuccessPopupTitle; },
/* harmony export */   "p7": function() { return /* binding */ checkoutTnCLink; }
/* harmony export */ });
/* unused harmony export getDcFreeTrialConfig */
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64687);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var _configService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66738);
/* harmony import */ var _configService__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_configService__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43354);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(___WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97322);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15616);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(date_fns_format__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _lib_loyaltyFetch__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7786);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);












var TermsDiv = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
  componentId: "sc-6yolo0-0"
})(["margin-top:1.5rem;"]);
var TermsRedirectText = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_components_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP).withConfig({
  componentId: "sc-6yolo0-1"
})(["cursor:pointer;"]);
var DigitalClubIcon = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].img.withConfig({
  componentId: "sc-6yolo0-2"
})(["margin-bottom:0.1rem;width:0.875rem;"]);
var getDcFreeTrialConfig = function getDcFreeTrialConfig() {
  return JSON.parse((0,_configService__WEBPACK_IMPORTED_MODULE_2__.getExpConfig)(___WEBPACK_IMPORTED_MODULE_3__.SPLIT_FEATURES.DC_FREE_TRIAL).config);
};
var checkoutTnCLink = function checkoutTnCLink() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TermsDiv, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
      size: "medium",
      color: "#696969",
      children: ["By joining the FairPrice Digital Club, you agree to the", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TermsRedirectText, {
        as: "a",
        color: "#1e5dc1",
        href: "https://help.fairprice.com.sg/hc/en-us/articles/360049899272-FairPrice-Digital-Club-Terms-and-Conditions",
        target: "_blank",
        children: "Terms and Conditions."
      }), ' ', "Your membership automatically renews monthly until terminated. You also authorise us to charge the monthly fee to your debit or credit card on our record."]
    })
  });
};
var checkoutTncHeader = function checkoutTncHeader(isUserEligibleForFreeTrial) {
  return "You will automatically be charged ".concat(isUserEligibleForFreeTrial ? 'once your 1-month trial ends' : '$9.99 monthly', ". \n  Cancel your subscription anytime in your Fairprice account > Digital Club.");
};
var cancelMembershipSuccessPopupTitle = function cancelMembershipSuccessPopupTitle(membershipAccount, cancellationDate, hasMembershipEnded, dateFormat) {
  if (membershipAccount !== null && membershipAccount !== void 0 && membershipAccount.freetrial) {
    return 'Membership Cancelled';
  } else {
    return !hasMembershipEnded ? "Your FairPrice Digital Club membership will end on ".concat(date_fns_format__WEBPACK_IMPORTED_MODULE_5___default()(cancellationDate.slice(0, -1), dateFormat), ".") : 'Your FairPrice Digital Club membership has been cancelled.';
  }
};
var getUserDcEligibility = /*#__PURE__*/function () {
  var _ref = (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var eligibility, packageId, res;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            packageId = getDcFreeTrialConfig().packageId;
            _context.t0 = packageId;

            if (!_context.t0) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return (0,_lib_loyaltyFetch__WEBPACK_IMPORTED_MODULE_6__/* .getDcFreeTrialEligibility */ .T9)({
              ctx: null,
              id: packageId
            });

          case 5:
            _context.t0 = _context.sent;

          case 6:
            res = _context.t0;
            res.packages.forEach(function (pack) {
              if (pack.package_id === parseInt(packageId)) {
                eligibility = pack.eligibility;
              }
            });
            return _context.abrupt("return", eligibility);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getUserDcEligibility() {
    return _ref.apply(this, arguments);
  };
}();
var checkoutServiceFooter = function checkoutServiceFooter(digitalClubConfig, hasFairPriceSeller, memberServiceFeeText, isMemberEnabled, digitalServiceFeeSwitch, isB2BUser, digitalIngressionFlag) {
  return digitalIngressionFlag ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
      size: "small",
      color: "#696969",
      children: ["Free for", ' ']
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(DigitalClubIcon, {
      alt: "Digital Club",
      src: digitalClubConfig === null || digitalClubConfig === void 0 ? void 0 : digitalClubConfig.iconUrl,
      "data-testid": "member-service-fee-icon-cart"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
      size: "small",
      color: "#333333",
      margin: "0 0.25rem 0 0",
      children: digitalClubConfig === null || digitalClubConfig === void 0 ? void 0 : digitalClubConfig.serviceFeeDCLabel
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
      size: "small",
      color: "#696969",
      children: "member"
    })]
  }) : isMemberEnabled && digitalServiceFeeSwitch && !isB2BUser && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(DigitalClubIcon, {
      alt: "Digital Club",
      src: digitalClubConfig === null || digitalClubConfig === void 0 ? void 0 : digitalClubConfig.iconUrl,
      "data-testid": "member-service-fee-icon-cart"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
      size: "small",
      color: "#333333",
      margin: "0 0.25rem 0 0",
      children: digitalClubConfig === null || digitalClubConfig === void 0 ? void 0 : digitalClubConfig.serviceFeeDCLabel
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
      size: "small",
      color: "#696969",
      children: hasFairPriceSeller ? memberServiceFeeText : 'members benefits'
    })]
  });
};

/***/ }),

/***/ 52923:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDI0QzE4LjYyNzQgMjQgMjQgMTguNjI3NCAyNCAxMkMyNCA1LjM3MjU4IDE4LjYyNzQgMCAxMiAwQzUuMzcyNTggMCAwIDUuMzcyNTggMCAxMkMwIDE4LjYyNzQgNS4zNzI1OCAyNCAxMiAyNFoiIGZpbGw9IiMyNjczNDgiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS40NTU4IDcuOTIzMTVDMTYuMDUwNSA3LjM0NjQ0IDE3LjAwMDEgNy4zNjEwNSAxNy41NzY5IDcuOTU1NzhDMTguMTUzNiA4LjU1MDUxIDE4LjEzODkgOS41MDAxNSAxNy41NDQyIDEwLjA3NjlMMTEuMzU2NyAxNi4wNzY5QzEwLjc3NDkgMTYuNjQxMSA5Ljg1MDExIDE2LjY0MTEgOS4yNjgyOCAxNi4wNzY5TDYuNDU1NzggMTMuMzQ5NkM1Ljg2MTA1IDEyLjc3MjkgNS44NDY0NCAxMS44MjMyIDYuNDIzMTUgMTEuMjI4NUM2Ljk5OTg2IDEwLjYzMzggNy45NDk0OSAxMC42MTkyIDguNTQ0MjIgMTEuMTk1OUwxMC4zMTI1IDEyLjkxMDZMMTUuNDU1OCA3LjkyMzE1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==");

/***/ }),

/***/ 30119:
/***/ (function(module) {

module.exports = "/_next/static/images/image@4x-c1958fcf9668219c80039a5cf46de73a.png";

/***/ }),

/***/ 69713:
/***/ (function(module) {

module.exports = "/_next/static/images/image-48ede56d0d11524ba0428e2c1395e7fd.jpg";

/***/ }),

/***/ 12232:
/***/ (function(module) {

module.exports = "/_next/static/images/image@2x-6391c5a4a5c58b54abd240f6ed469f9d.jpg";

/***/ }),

/***/ 63985:
/***/ (function(module) {

module.exports = "/_next/static/images/image@3x-047a5bf3f6c32fcb25409ccccdd12daa.jpg";

/***/ })

}]);